module.exports = __webpack_public_path__ + "img/logo-om.fde9fdb5.svg";